import LegalLayout from "@/components/site/LegalLayout";

const TERMS = [
  {
    title: "1 · Non-Refundable Registration",
    body: "All registration/participation fees paid towards the BoT Summit are non-refundable and non-cancellable once the participation has been confirmed and payment received.",
  },
  {
    title: "2 · Participation Confirmation",
    body: "Payment of the invoice constitutes acceptance of the confirmed participation package and the deliverables communicated by the BoT team.",
  },
  {
    title: "3 · Deliverables",
    body: "All benefits and deliverables will be provided in accordance with the participation package agreed and communicated separately with the participant/organization.",
  },
  {
    title: "4 · Editorial",
    body: "Editorial features, panel discussions, keynote sessions, fireside chats, or other speaking formats are subject to editorial guidelines, speaker suitability, agenda requirements, and final confirmation by the BoT editorial team.",
  },
  {
    title: "5 · Content Approval",
    body: "Wherever applicable, editorial or promotional content requiring participant/brand approval will be shared for review prior to publication. Delays in providing information or approvals may affect the corresponding deliverables.",
  },
  {
    title: "6 · Event Schedule",
    body: "The organizer reserves the right to make reasonable changes to the event date, venue, agenda, speakers, session timings, or format due to operational requirements or circumstances beyond its reasonable control.",
  },
  {
    title: "7 · Rescheduling",
    body: "In the event the summit is rescheduled, the registration will automatically remain valid for the revised date/edition, and the participation fee will not become refundable solely due to such rescheduling.",
  },
  {
    title: "8 · Taxes",
    body: "GST and other applicable statutory taxes will be charged as per prevailing government regulations.",
  },
  {
    title: "9 · Outstanding Payments",
    body: "Participation benefits and deliverables may be withheld or suspended until all applicable payments against the invoice have been received.",
  },
];

export default function PaymentTerms() {
  return (
    <LegalLayout
      eyebrow="/ Policy · Payment Terms"
      title="Payment Terms"
      updated="February 2026"
    >
      <p className="lead text-lg text-zinc-700 leading-relaxed">
        These payment terms govern all registrations, sponsorships and participation
        packages purchased for BoT Summit 2026. By completing payment against a BoT
        Summit invoice, the participant/organization confirms acceptance of the
        terms set out below.
      </p>

      <div className="mt-12 space-y-10">
        {TERMS.map((s, i) => (
          <section key={i} data-testid={`payment-terms-section-${i}`}>
            <h2 className="font-display text-xl md:text-2xl uppercase tracking-tight border-t border-zinc-200 pt-6">
              {s.title}
            </h2>
            <p className="mt-4 text-zinc-700 leading-relaxed">{s.body}</p>
          </section>
        ))}
      </div>

      <div className="mt-16 p-6 border border-zinc-200 bg-zinc-50">
        <div className="overline text-zinc-500 mb-2">Questions on invoicing</div>
        <div className="font-mono text-sm">
          Email: info@botsummits.com · WhatsApp: +44 7915361665 · +91 8825035701 · +971 525330661
        </div>
      </div>
    </LegalLayout>
  );
}
